import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import Highcharts from 'highcharts';

// Normalize Highcharts text rendering across browsers
Highcharts.setOptions({
  chart: {
    style: {
      fontFamily: 'Inter, system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
    }
  },
  credits: {
    enabled: true,
    text: 'Powered by StockFortress',
    href: 'https://stockfortress.com',
    style: {
      color: 'rgba(255, 255, 255, 0.4)',
      fontSize: '12px',
      fontWeight: '400',
      cursor: 'pointer'
    },
    position: {
      align: 'right',
      x: -10,
      y: -5
    }
  }
});

render(<App />, document.getElementById('root'));